import { render, staticRenderFns } from "./e-learningSubCategory.vue?vue&type=template&id=58fc19a6"
import script from "./e-learningSubCategory.vue?vue&type=script&lang=js"
export * from "./e-learningSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports